import {Base} from "@/api/Base"

export class SalaryConfirm extends Base {
    path = "salary/confirm"
}